export default __webpack_public_path__ + "static/8-fe51add6ccb30f1ad7e7cdbca52a89d4.png";